module.exports = __webpack_public_path__ + "img/chat_doc.30ad57b2.svg";